import type { JSX } from 'react';
import { Outlet } from 'react-router';
import * as styles from './PublicLayout.css.js';
import { BrandHeader } from '../BrandHeader/BrandHeader.js';
export function PublicLayout(): JSX.Element {
  return (
    <>
      <BrandHeader />
      <div className={styles.content}>
        <Outlet />
      </div>
    </>
  );
}
